; (function ($, _, root) {
    var common = require('../common');
    var stat = require('../modules/stat');
    var api = require('../modules/xl_api');
    var adBase = require('./base');
    
    var $container;
    
    /**
     * 通栏广告
     * @constructor
     */
    var App = {
        _order: {},
        
        init: function (positionId, selector) {
            $container = $(selector);
            adBase.load(positionId, function (order) {
                App._order = order;
                if (!App._order) {
                    return;
                }
                
                App.render();
                App.events();
            });
        },
        
        render: function () {
            var data = App._order.data;
            if (!data) {
                return;
            }
            
            var type = data.materials[0].data[0].type;
            switch (type) {
                case 'flash':
                    App.flashRender(data);
                    break;
                case 'img':
                    App.imageRender(data);
            }
        },
        
        imageRender: function (data) {
            var src = data.materials[0].data[0].value;
            $container.show()
                .html('<a href="javascript:;"><img src="' + src + '?v=' + common.timestamp + '" /></a>');
        },
        
        flashRender: function (data) {
            var src = data.materials[0].data[0].url;
            var html = '<embed width="100%" height="100%" type="application/x-shockwave-flash" wmode="transparent" src="' + src + '"> \
                       <a style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; background: url(about:blank);" href="javascript:;"></a>';
            if (common.isIE()) {
                $container.html(html).show();
                App._resizeHandler();
            } else {
                // chrome核等浏览器小尺寸flash不会自动播放，先把高度放大再缩小可解决这个问题
                $container.height(400);
                $container.html(html).show();
                setTimeout(function () {
                    $container.height(App._getContainerHeight());
                }, 50);
            }
            
            $(root).on('resize', App._resizeHandler);
        },
        
        events: function () {
            var data = App._order.data;
            if (!data) {
                return;
            }
            
            var open_type = data.materials[0].open_type;
            
            // 1 内嵌tab页
            // 2 指定客户端
            // 3 直接下载
            // 4 无
            switch (open_type) {
                case 1:
                case 2:
                    this.newTabEvent(data, open_type);
                    break;
                case 3:
                case 4:
                    this.restEvent(data);
                    break;
            }
        },
        
        // 打开新窗口(客户端或新页面窗口)
        newTabEvent: function (data, open_type) {
            var material = data.materials[0];
            var link = material.open_url;
            var bakLink = material.data[1] && material.data[1].value;
            $container.on('click', 'a', function () {
                if (open_type === 1) {
                    root.open(link);
                }
                if (open_type === 2) {
                    var ret = api.openGame(link);
                    if (!ret && bakLink) {
                        root.open(bakLink);
                    }
                }
            });
            
            this.allStat();
        },
        
        restEvent: function (data) {
            this.explodeStat();
        },
        
        // 展示统计
        explodeStat: function () {
            var data = App._order.data;
            if (!data) {
                return;
            }
            
            var extraData = this._getExtraData(data);
            stat.trackEvent('ad_event', 'ad_show', data.positionId, 0, 0, 0, 0, extraData);
            App._order.statShow();
        },
        
        // 展示、点击统计
        allStat: function () {
            var data = App._order.data;
            if (!data) {
                return;
            }
            
            var extraData = this._getExtraData(data);
            stat.trackEvent('ad_event', 'ad_show', data.positionId, 0, 0, 0, 0, extraData);
            App._order.statShow();
            $container.on('click', 'a', function () {
                stat.trackEvent('ad_event', 'ad_click', data.positionId, 0, 0, 0, 0, extraData);
                App._order.statClick();
            });
        },
        
        _getContainerHeight: function () {
            return common.isBSWindow() ? 90 : 71;
        },
        
        _resizeHandler: function () {
            if (!App._lastStatus || App._lastStatus !== App._getContainerHeight()) {
                App._lastStatus = App._getContainerHeight();
                $container.height(App._lastStatus);
            }
        },
        
        _getExtraData: function (data) {
            var extraData = '';
            extraData += 'orderid=' + data.orderId;
            extraData += ',templateid=' + data.materials[0].material_id;
            return extraData;
        }
    };
    
    if (typeof exports === 'object') {
        module.exports = App;
    }
})(jQuery, _, window);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/advertisement/full_column.js
// module id = 65
// module chunks = 10 12